/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import gatewayLogTemplate from './gateway-log.tpl.html'

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function GatewayLogRouters($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.gatewayLogs', {
            url: '/gatewayLogs',
            module: 'private',
            auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value,
                   types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: gatewayLogTemplate,
                    controllerAs: 'vm',
                    controller: 'GatewayLogController'
                }
            },
            data: {
                pageTitle: 'gateway-log.gateway-logs'
            },
            ncyBreadcrumb: {
                label: '{"icon": "track_changes", "label": "gateway-log.gateway-logs"}'
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/gateway-log/gateway-log.routes.js